exports.list = {
    path: '/retur_equipment',
    name: 'retur_equipment_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/retur_equipment/List.vue"),
}
exports.show = {
    path: '/retur_equipment/show/:id',
    name: 'retur_equipment_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/retur_equipment/Show.vue"),
}